import Anchor from '../components/general/anchor.component';
import VideoBehindText from '../components/video-image-background/video-behind-text.component';
//import tw from "twin.macro";



const SupportPage = () => (
   <VideoBehindText mainText="Support" url="bg.jpg">
      <div className="grid place-items-center">
         <div className="py-8">
            If you want to support me as I create more music Buy Me A Coffee here:
         </div>
         <div>
            <a href="https://www.buymeacoffee.com/eloch" target="_blank" rel="noreferrer">
               <img src="images/buymeacoffee.png" alt="Buy Me A Coffee Logo" className='buymeacoffee' />
            </a>
         </div>
         <div className="pt-8"> Or become a Patron here: </div>
         <div className="flex">
            <img src="Digital-Patreon-Logo_FieryCoral.png" alt="Patreon Logo" width="40px" height="40px" />
            <Anchor url="https://www.patreon.com/bePatron?u=35537290" text="Become a Patron!" />
         </div>
         <div className="pt-8">
            If you want to subscribe to my mailing list click here:
            <Anchor url="https://mailchi.mp/6ab6431253ac/ethandavidloch" text="MailChimp mailing list page" />
         </div>
      </div>
   </VideoBehindText>
);

export default SupportPage;